// import people from "../../assets/sessions-icons/people.png";
import BrittanyMcGee from "../../assets/speaker-imgs/BrittanyMcGee.jpg"; 
// import HodaSolati from "../../assets/speaker-imgs/HodaSolati.png"; 
import JCPrice from "../../assets/speaker-imgs/JCPrice.jpeg";
// import JennaRitten from "../../assets/speaker-imgs/JennaRitten.jpg";
import JessicaHoopfer from "../../assets/speaker-imgs/JessicaHoopfer.jpg";
// import KanikaMohan from "../../assets/speaker-imgs/KanikaMohan.jpeg";
import KavithaBangalore from "../../assets/speaker-imgs/KavithaBangalore.jpg";
import LorrenaBlack from "../../assets/speaker-imgs/LorrenaBlack.jpg"
import MattalynnDarden from "../../assets/speaker-imgs/MattalynnDarden.jpeg";
import ShantaleaJohns from "../../assets/speaker-imgs/ShantaleaJohns.jpg";
// import ShimaSolati from "../../assets/speaker-imgs/ShimaSolati.jpg";
import ShrutiAgarwal from "../../assets/speaker-imgs/ShrutiAgarwal.png";
import ShimaHoda from "../../assets/speaker-imgs/ShimaHoda.png";

const talkSeminarsCards = [
  
  {
    title: "Unlock Your Future: How to Master Community Networks for Invisible Career Advantages",
    imageUrl: JCPrice,
    time: "9:45 AM",
    // place: "G.O. 9th floor auditorium",
    description:
      "Enlightening presentation on ways to enhance your professional development through utilizing networks",
    type: "regular",
    speaker: "JC Price @ Scope Focus",
    showImageBorder: true,
  },
  {
    title:
      "The AI Era and Your Digital Footprint: What You Need to Know",
    imageUrl:  KavithaBangalore,
    time: "10:00 AM",
    // place: "G.O. 9th floor auditorium",
    description:
      "Learn the risks of AI-driven data collection and get practical tips to protect your privacy and control your digital identity in today's connected world.",
    type: "regular",
    speaker: "  Kavitha Bangalore @ Cleveland Clinic",
    showImageBorder: true,
  },

  {
    title: "Inclusive Smart Mobility: Enhancing Social Inclusion through Technology",
    imageUrl: ShimaHoda,
    time: "10:30 AM",
    // place: "G.O. 9th floor auditorium",
    description:
      "This session will explore the design process, challenges, and innovations behind creating a truly inclusive parking solution.",
    type: "regular",
    speaker: "Hoda Solati & Shima Solati @ BraunAbility",
    showImageBorder: true,
  },
  {
    title:
      "Your Natural Blueprint: Redefining Your Impact and Presence, Unlocking Leadership",
    imageUrl: ShrutiAgarwal,
    time: "11:00 AM",
    // place: "G.O. 9th floor auditorium",
    description:
      "Discover how to align your unique strengths with the power of AI to create lasting impact. This session will help you move beyond personal success to build a legacy that inspires change in your organization, community, and future leaders.",
    type: "regular",
    speaker: "Shruti Agarwal @ Levelwing Media LLC",
    showImageBorder: true,
  },
  {
    title: "Building a Global Tech Career Through Experience",
    imageUrl: JessicaHoopfer,
    time: "11:30 AM",
    // place: "G.O. 9th floor auditorium",//"Main Hall"
    description:
      "Learn how to build a global tech career without a traditional path. This session explores how experience, remote work, and inclusion—not location or degrees—are redefining success. Discover how women are leading in AI and how you can break in, level up, and lead from anywhere.",
    type: "social",
    speaker: "Jessica Hoopfer",
    showImageBorder: true,
  },


  {
    title: "Resilient Minds, Thriving Careers: Mental Health Strategies for Women in Tech",
    imageUrl: ShantaleaJohns,
    time: "2:00 PM",
    // place: "Main Hall",
    description: "This session will provide actionable mental health strategies tailored for women in tech, empowering them to sustain resilience, manage stress, and cultivate a thriving career.",
    type: "regular",
    speaker: "Shantalea Johns",
    showImageBorder: true,
  },
  {
    title: "Breaking into Cybersecurity",
    imageUrl: MattalynnDarden,
    time: "2:30 PM",
    // place: "Main Hall",
    description: "Cybersecurity can feel overwhelming, but it doesn’t have to be. This session is designed for small business owners and entrepreneurs who want to understand cybersecurity in a simple, practical way. Learn how to identify risks, protect your data, and build a security-first mindset—without needing a big budget or technical expertise. Whether you are just starting out or looking to strengthen your defenses, you will leave with actionable steps to secure your business.",
    type: "regular",
    speaker: "Mattalynn Darden",
    showImageBorder: true,
  },
  {
    title: "When the Imposter is Me: Overcoming Self-Doubt to Lead and Innovate",
    imageUrl: LorrenaBlack,
    time: "3:00 PM",
    // place: "Main Hall",
    description: "In this engaging session, we’ll break down the imposter phenomenon, why it happens, and how to break free from it. Through interactive discussion and real-world strategies, attendees will learn how to reframe self-doubt, build confidence, and step into their leadership potential—without waiting for external validation.",
    type: "regular",
    speaker: "Lorrena Black",
    showImageBorder: true,
  },
  {
    title: "Tech Unfiltered: Changing The Game",
    imageUrl: BrittanyMcGee,
    time: "3:30 PM",
    // place: "Main Hall",
    description: "Technology in the current days. This session dives into the real stories behind breaking into tech—no gatekeeping, no fluff. We’ll explore how unconventional paths, diverse voices, and unapologetic authenticity are reshaping the industry and driving meaningful innovation.",
    type: "social",
    speaker: "Brittany McGee",
    showImageBorder: true,
  }, 
];

export default talkSeminarsCards;
